export default {
  get: (key: string) =>
    localStorage.getItem(key) && JSON.parse(localStorage.getItem(key) || ''),
  set: (key: string, data: any) =>
    localStorage.setItem(key, JSON.stringify(data)),
  clear: () => localStorage.clear(),
  clearWithKey: (key: string) => localStorage.removeItem(key),
};
